module.exports = __webpack_public_path__ + "static/zine-image-d3788c3a6a00ad9fc23dfc1af0b1d90a.png";